import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { NgIf, NgFor } from '@angular/common';
import { DashboardCard, HelplineData } from '../../../interfaces/strapi';
import HeaderComponent from '../header/header.component';

@Component({
    selector: 'app-student-wellbeing-carousel',
    templateUrl: './student-wellbeing-carousel.component.html',
    styleUrls: ['./student-wellbeing-carousel.component.scss'],
    imports: [
        NgIf,
        NgFor,
        HeaderComponent,
    ],
})
export class StudentWellbeingCarouselComponent
  implements AfterViewInit, OnDestroy
{
  @ViewChild('sliderRef') private readonly sliderRef!: ElementRef<HTMLElement>;

  @Input() public carousel: DashboardCard[] = [];

  @Input() public helplineData!: HelplineData;

  @HostListener('window:resize')
  onScreenChange() {
    this.isMobile = window.innerWidth < 992;
  }

  public isMobile: boolean = window.innerWidth < 992;

  public currentSlideIndex = 0;

  public slider: KeenSliderInstance | null = null;

  ngAfterViewInit() {
    if (this.sliderRef) {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        loop: false,
        mode: 'free-snap',
        slides: {
          perView: 'auto',
          spacing: 8,
        },

        breakpoints: {
          '(min-width: 992px)': {
            loop: this.showArrows,
            slides: {
              perView: 3,
              spacing: 15,
            },
          },
        },
        slideChanged: (s) => {
          this.currentSlideIndex = s.track.details.abs;
        },
      });
    }
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
  }

  public get showArrows(): boolean {
    return this.carousel && this.carousel.length > 3;
  }

  public doPrev(): void {
    this.slider?.prev();
  }

  public doNext(): void {
    this.slider?.next();
  }
}
